module.exports = __webpack_public_path__ + "static/coffee-beans-5712774_1920-fc3726db8bcb21eaad9bfecaff37905a.png";